<div class="cr-header-wrapper" [class.no-border]="!showBorder" [ngClass]="cssClasses">
  <div class="header">
    <ng-container [ngSwitch]="headingLevel">
      <h1 *ngSwitchCase="1">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h1>

      <h2 *ngSwitchCase="2">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h2>

      <h3 *ngSwitchCase="3">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h3>

      <h4 *ngSwitchCase="4">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h4>

      <h5 *ngSwitchCase="5">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h5>

      <h6 *ngSwitchCase="6">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </h6>

      <div *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </div>
    </ng-container>

    <ng-template #headerContent>
      <div *ngIf="innerHTML; else projected" [innerHTML]="innerHTML"></div>

      <ng-template #projected>
        <ng-content></ng-content>
      </ng-template>
    </ng-template>
  </div>

  <cr-button
    *ngIf="buttonText"
    [isLoading]="isLoading"
    [isDisabled]="isDisabled"
    [requiredPermissions]="buttonRequiredPermissions"
    [routerLink]="buttonRouterLink"
    [goBack]="buttonGoBack"
    (clicked)="onClick()">
    {{ buttonText }}
  </cr-button>
</div>
